import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";

const query = `
  query GraphicSets($offset: Int, $limit: Int, $customerId: ID) {
    graphicsets(offset: $offset, limit: $limit, customerId: $customerId) {
      items {
        id
        name
      }
      total
    }
  }
`;

const GraphicSetSelect = ({ id = "graphicSetId", name = "graphicSetId", isInsideForm, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.graphicsets, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.name, []);


  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

GraphicSetSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default GraphicSetSelect;
